import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-wrapper"
}

import AppSpinnerIcon from "@/components/AppSpinnerIcon.vue";
import {useStore} from "vuex";
import {computed, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSpinner',
  setup(__props) {

const store = useStore()

const show = computed(() => store.state.showSpinner)

const disableBackCallback = (e: any) => e.preventDefault()

watch(show, () => {
  if (show.value) {
    document.addEventListener('backbutton', disableBackCallback)
  } else {
    document.removeEventListener('backbutton', disableBackCallback)
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AppSpinnerIcon)
      ]))
    : _createCommentVNode("", true)
}
}

})